import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Sidebar from './sidebar';
import LoginComponent from '../login';
import LoginStyles from '../LoginStyles';



const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [wheels, setWheels] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Declare selectedWheel state here
  const [selectedWheel, setSelectedWheel] = useState(null);

  console.log("firstname", selectedWheel);
  const [selectedWheelprice, setSelectedWheelprice] = useState('');

  // Add dynamic fee and tax rate fields
  const [additionalFee, setAdditionalFee] = useState('70');
  const [taxRate, setTaxRate] = useState('4');

  const [subtotal, setSubtotal] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  // Update the calculation functions to use dynamic values
  const calculateTotals = (price, fee, tax) => {
    const priceValue = parseInt(price) || 0;
    const feeValue = parseInt(fee) || 0;
    const taxRateValue = parseFloat(tax) || 0;

    const subtotalValue = priceValue + feeValue;
    const taxValue = subtotalValue * (taxRateValue / 100);
    const totalValue = subtotalValue + taxValue;

    setSubtotal(subtotalValue);
    setTaxAmount(taxValue);
    setTotalAmount(totalValue);
  };

  const calculateSubtotal = () => {
    const priceValue = parseInt(selectedWheelprice) || 0;
    const feeValue = parseInt(additionalFee) || 0;
    return (priceValue + feeValue).toFixed(2);
  };

  const calculateTax = () => {
    const taxRateValue = parseFloat(taxRate) || 0;
    return (calculateSubtotal() * (taxRateValue / 100)).toFixed(2);
  };

  const calculateTotal = () => {
    return (parseFloat(calculateSubtotal()) + parseFloat(calculateTax())).toFixed(2);
  };

  // Update useEffect to include new dynamic values
  useEffect(() => {
    if (selectedWheel && selectedWheelprice) {
      calculateTotals(selectedWheelprice, additionalFee, taxRate);
    }
  }, [selectedWheel, selectedWheelprice, additionalFee, taxRate]);


  const [items, setItems] = useState({
    total_wheel: 0,
    published_wheel: 0,
    completed_wheel: 0,
    deleted_wheel: 0,
    expired_wheel: 0,
    wfa_wheel: 0
  });

  // Authentication state
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState('');
  const [errorprice, setErrorprice] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  // Leads popup states
  const [showLeadsPopup, setShowLeadsPopup] = useState(false);
  const [selectedWheelLeads, setSelectedWheelLeads] = useState([]);
  const [selectedWheelName, setSelectedWheelName] = useState('');
  const [isLoadingLeads, setIsLoadingLeads] = useState(false);
  const [leadsCurrentPage, setLeadsCurrentPage] = useState(1);
  const [leadsPerPage] = useState(5);
  const [leadsTotalPages, setLeadsTotalPages] = useState(1);

  // Confirmation popup states
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Check if admin is already verified
    const adminVerified = localStorage.getItem('adminVerified');
    if (adminVerified === 'true') {
      setIsVerified(true);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isVerified) {
      wheelsList();
      wheelItems();
    }
  }, [isVerified, currentPage, searchTerm]);

  const handleLoginSuccess = () => {
    setIsVerified(true);
  };

  const fetchWheeledit = (value) => {
    navigate(`/wheeledit?key=${value}`);
  };


  // Modify the wheelsList function to only update the table data
 const wheelsList = async (pageNumber = currentPage) => {

    setTableLoading(true);

    const payload = {
      apikey: process.env.REACT_APP_API_KEY,
      module: "admin",
      method: "adminWheelList",
      page: pageNumber,
      limit: itemsPerPage,
      wheelStatus: "",
      search_text: searchTerm
    };

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      const jsonData = JSON.parse(response.data.body);

      console.log("jsonData", jsonData);
      if (jsonData.status === "success") {
        setWheels(jsonData.result.wheels);
        const total = jsonData.result.totalItems || jsonData.result.wheels.length;
        setTotalPages(Math.max(1, Math.ceil(total / itemsPerPage)));
      } else {
        setError("Failed to fetch wheels data");
      }
    } catch (err) {
      setError("Error loading dashboard data");
    } finally {
      setTableLoading(false);
    }
  };

  const wheelItems = async () => {
    const payload = {
      apikey: process.env.REACT_APP_API_KEY,
      module: "admin",
      method: "adminDashboard"
    };

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      const jsonData = JSON.parse(response.data.body);

      if (jsonData.status === "success") {
        setItems(jsonData.result);
      } else {
        console.error("Error fetching dashboard items");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLeads = async (playerData, wheelName) => {
    setIsLoadingLeads(true);
    setSelectedWheelName(wheelName);

    setLeadsCurrentPage(1);

    try {
      if (playerData && Array.isArray(playerData)) {
        const formattedLeads = playerData.map(player => ({
          phone_number: player.phone_number,
          created_date: player.created_date
        }));
        setSelectedWheelLeads(formattedLeads);
        setLeadsTotalPages(Math.max(1, Math.ceil(formattedLeads.length / leadsPerPage)));
      } else {
        setSelectedWheelLeads([]);
        setLeadsTotalPages(1);
      }
    } catch (err) {
      console.error("Error processing leads:", err);
      setSelectedWheelLeads([]);
      setLeadsTotalPages(1);
    } finally {
      setIsLoadingLeads(false);
    }
  };

  const handlePrevPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };

  const handlePrevLeadsPage = () => {
    setLeadsCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const handleNextLeadsPage = () => {
    setLeadsCurrentPage(prev => Math.min(prev + 1, leadsTotalPages));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const formatPrice = (price) => {
    if (!price) return '-';
     //commented by barath
    // return price.includes('$') ? price : `$${price}`;
    return price.includes('₹') ? price : `₹${price}`;
  };

  const handleStatusClick = (wheel) => {
    if (wheel.status === "wfa") {
      setSelectedWheel(wheel);
      console.log("testing", wheel);
      setShowConfirmPopup(true);
    }
  };

  const handleConfirmation = async () => {
    if (!selectedWheelprice) {
      setErrorprice(true);
      return;
    }

    setIsConfirming(true);
    const totalcalculateTotal = calculateTotal();
    console.log('totalcalculateTotal', totalcalculateTotal);

    try {
      const payload = {
        apikey: process.env.REACT_APP_API_KEY,
        module: "twheel",
        method: "tWheelCollectionUpdate",
        wheel_id: selectedWheel._id,
        creatorid: selectedWheel._id,
        price: totalcalculateTotal,
        status: "paymentpending"
      };
      console.log('payload----', payload);
      const response = await axios.post(process.env.REACT_APP_API_URL, payload);
      const jsonData = JSON.parse(response.data.body);


      console.log("jsonData", jsonData)


      if (jsonData.status === "success") {
        wheelsList();
        wheelItems();
        setShowConfirmPopup(false);
        setSelectedWheel(null);
        setSelectedWheelprice(null);
      } else {
        setError("Failed to update wheel status");
      }
    } catch (err) {
      setError("Error updating wheel status");
    } finally {
      setIsConfirming(false);
    }
  };
        //commented by barath
  // const handleViewDetails = (wheelId) => {
  //   navigate(`/wheel/details?key=${wheelId}`);
  // };

  // Get current leads for pagination
  const indexOfLastLead = leadsCurrentPage * leadsPerPage;
  const indexOfFirstLead = indexOfLastLead - leadsPerPage;
  const currentLeads = selectedWheelLeads.slice(indexOfFirstLead, indexOfLastLead);

  return (
    <>
      <LoginStyles />


      <style>
        {`
          /* Base styles */
          .dashboard-wrapper {
            display: flex;
            min-height: 100vh;
          }

          /* Responsive sidebar */
          .sidebar {
            background: #27285C;
            width: ${isSidebarOpen ? '250px' : '0'};
            transition: width 0.3s ease;
            overflow: hidden;
            position: fixed;
            height: 100vh;
            z-index: 1000;
          }

          /* Stats Cards */
          .stats-container {
            display: flex;
            gap: 1rem;
            margin-bottom: 2rem;
            flex-wrap: wrap;
            justify-content: center;
            padding: 0 1rem;
            padding-top: 2rem;
          }

          .stat-card {
            flex: 1;
            min-width: 78px;
            max-width: 115px;
            padding: 1rem;
            border-radius: 10px;
            color: white;
            text-align: center;
            margin-bottom: 1rem;
            flex-basis: calc(50% - 1rem);
          }

          .stat-title {
            font-size: 1.1rem;
            margin-bottom: 0.5rem;
          }

          .stat-value {
            font-size: 2rem;
            font-weight: bold;
          }

          /* Table Styles */
          .table-container {
            background: white;
            border-radius: 10px;
            padding: 1.5rem;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            overflow-x: auto;
            margin: 0 1rem;
          }

          .table-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            flex-wrap: wrap;
            gap: 1rem;
          }

          .search-box {
            padding: 0.5rem 1rem;
            border: 1px solid #ddd;
            border-radius: 5px;
            width: 100%;
            max-width: 300px;
          }

          .main-content {
            flex: 1;
            margin-left: ${isSidebarOpen ? '250px' : '0'};
            transition: margin-left 0.3s ease;
            padding-left: 18rem;
            width: 100%;
          }

          .total { background: #0066ff; }
          .active { background: #00CC66; }
          .completed { background: #ff4444; }
          .waiting { background: #e4c604; }
          .expired { background: #3d2f2f; } 
          .deleted { background: #5b5757; }
          
          table {
            width: 100%;
            border-collapse: collapse;
            min-width: 800px;
          }

          th, td {
            padding: 1rem;
            text-align: left;
            border-bottom: 1px solid #eee;
          }

          /* Status Badge */
          .status-badge {
            padding: 0.5rem 1rem;
            border-radius: 20px;
            font-size: 0.9rem;
            display: inline-block;
            white-space: nowrap;
          }

          .status-published {
            background: #e0f7ea;
            color: #00cc66;
          }

          .status-ended {
            background: rgb(233, 11, 33);
            color: rgb(251 247 247);
          }

          .status-wfa {
            background: rgb(234, 234, 21);
            color: rgb(14 14 14);
          }
            .status-paymentpending {
            background: rgb(246, 214, 156);
            color: rgb(14 14 14);
          }
              
          .status-deleted {
            background: rgb(229 229 235);
            color: rgb(14 14 14);
          }

          /* Responsive styles */
          @media (max-width: 768px) {
            .sidebar {
              width: ${isSidebarOpen ? '100%' : '0'};
              position: fixed;
              top: 0;
              left: 0;
              z-index: 1000;
            }

            .main-content {
              margin-left: 0 !important;
              padding: 1rem;
              width: 100%;
            }

            .stats-container {
              flex-direction: column;
              align-items: center;
            }

            .stat-card {
              width: 30%;
              max-width: 50%;
              margin-bottom: 0.3rem;
            }

            .table-container {
              padding: 1rem;
              margin: 0;
            }

            .table-responsive {
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
            }

            .table-header {
              flex-direction: column;
              align-items: flex-start;
            }

            .search-box {
              width: 100%;
              max-width: 100%;
            }
          }

          /* Leads Popup */
          .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          .popup-content {
            background: white;
            padding: 2rem;
            border-radius: 10px;
            width: 90%;
            max-width: 700px;
            max-height: 90vh;
            overflow-y: auto;
          }

          @media (max-width: 768px) {
            .popup-content {
              padding: 1rem;
              width: 95%;
              max-height: 80vh;
            }
          }

          .popup-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
          }

          .close-button {
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            padding: 0.5rem;
            color: #666;
          }

          /* Pagination */
          .pagination-controls {
            display: flex;
            justify-content: center;
            gap: 1rem;
            margin-top: 1.5rem;
            align-items: center;
            flex-wrap: wrap;
          }

          .pagination-button {
            padding: 0.5rem 1rem;
            border: 1px solid #ddd;
            border-radius: 5px;
            background: white;
            cursor: pointer;
            transition: all 0.3s;
          }

          .pagination-button:disabled {
            background: #f5f5f5;
            cursor: not-allowed;
            opacity: 0.7;
          }

          /* Action Buttons */
          .action-btn {
            margin: 0 0.25rem;
            padding: 0.25rem 0.5rem;
            border: none;
            background: none;
            cursor: pointer;
            font-size: 1.1rem;
            transition: all 0.2s ease;
          }

          .action-btn:hover {
            transform: scale(1.1);
            opacity: 0.8;
          }

          .action-btn:active {
            transform: scale(0.95);
          }

          .loading-tbody {
            position: relative;
            opacity: 0.7;
            transition: opacity 0.3s;
          }

          .loading-tbody::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .table-container {
            position: relative;
          }
          
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.7; }
            100% { opacity: 1; }
          }

          .loading-tbody {
            animation: pulse 1s infinite;
          }

          .loading-message {
            text-align: center;
            padding: 2rem;
            color: #666;
          }

          .table-loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 300px;
            width: 100%;
          }

          .table-spinner {
            width: 30px;
            height: 30px;
            border: 3px solid rgba(26, 35, 126, 0.1);
            border-radius: 50%;
            border-top-color: #1a237e;
            animation: spin 1s ease-in-out infinite;
            margin-bottom: 0.5rem;
          }

          .wheel-details {
            margin-bottom: 1.5rem;
          }

          .wheel-detail-item {
            display: flex;
            margin-bottom: 0.75rem;
            padding: 0.5rem;
            background: #f8f9fa;
            border-radius: 6px;
            flex-wrap: wrap;
          }

          .detail-label {
            font-weight: 500;
            width: 140px;
            color: #666;
          }

          .detail-value {
            color: #333;
            flex: 1;
          }

          .popup-buttons {
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
            margin-top: 2rem;
            flex-wrap: wrap;
          }

          .popup-button {
            padding: 0.75rem 1.5rem;
            border-radius: 6px;
            border: none;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s;
          }

          .confirm-button {
            background: #4caf50;
            color: white;
          }

          .confirm-button:hover {
            background: #43a047;
          }

          .cancel-button {
            background: #f5f5f5;
            color: #666;
          }

          .cancel-button:hover {
            background: #e0e0e0;
          }

          .status-cell {
            cursor: pointer;
          }

          .leads-table-container {
            margin-top: 1rem;
            margin-bottom: 1rem;
            overflow-x: auto;
          }

          .leads-table {
            width: 100%;
            border-collapse: collapse;
          }

          .leads-table th, .leads-table td {
            padding: 0.75rem;
            border-bottom: 1px solid #eee;
            text-align: left;
          }

          .leads-table th {
            background-color: #f5f5f5;
            font-weight: 500;
          }

          .leads-table tr:hover {
            background-color: #f9f9f9;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          /* Additional mobile responsive improvements */
          .sidebar-content {
            padding: 1rem;
            width: 250px;
            color: white;
            height: 100%;
            display: flex;
            flex-direction: column;
          }

          .menu-item {
            padding: 0.8rem 1rem;
            color: white;
            text-decoration: none;
            display: block;
            margin: 0.5rem 0;
            border-radius: 5px;
            transition: background 0.3s;
          }

          .menu-item:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          /* Mobile table view improvements */
          @media (max-width: 600px) {
            .table-responsive {
              position: relative;
            }
            
            .mobile-table-indicator {
              display: block;
              text-align: center;
              padding: 0.5rem;
              color: #666;
              font-style: italic;
              margin-bottom: 0.5rem;
            }

            .stat-card {
              flex-basis: 100%;
            }
          }
        `}
      </style>
      {isLoading ? (
        <div className="loading-message">Loading dashboard...</div>
      ) : !isVerified ? (
        <LoginComponent onLoginSuccess={handleLoginSuccess} />
      ) : (
        <div className="dashboard-wrapper">
          <Sidebar />
          <div className="main-content">
            {error ? (
              <div className="error-message">{error}</div>
            ) : (
              <>
                {/* Stats Cards */}
                <div className="stats-container">
                  <div className="stat-card total">
                    <div className="stat-title">Total Wheels</div>
                    <div className="stat-value">{items.total_wheel}</div>
                  </div>
                  <div className="stat-card active">
                    <div className="stat-title">Active</div>
                    <div className="stat-value">{items.published_wheel}</div>
                  </div>
                  <div className="stat-card completed">
                    <div className="stat-title">Completed</div>
                    <div className="stat-value">{items.completed_wheel}</div>
                  </div>
                  <div className="stat-card deleted">
                    <div className="stat-title">Deleted</div>
                    <div className="stat-value">{items.deleted_wheel}</div>
                  </div>
                  <div className="stat-card expired">
                    <div className="stat-title">Payment Pending</div>
                    <div className="stat-value">{items.paymentpending_wheel}</div>
                  </div>
                  <div className="stat-card waiting">
                    <div className="stat-title">Waiting For Approval</div>
                    <div className="stat-value">{items.wfa_wheel}</div>
                  </div>
                </div>

                {/* Data Table */}
                <div className="table-container">
                  <div className="table-header">
                    <h2>All Wheels</h2>
                    <input
                      type="text"
                      className="search-box"
                      placeholder="Search wheels..."
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                  </div>

                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Creator Name</th>
                          <th>Phone Number</th>
                          <th>Wheel Name</th>
                          <th>Spin Date</th>
                          <th>Status</th>
                          <th>Prize</th>
                          <th>Payment Status</th>
                          <th>Leads</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className={tableLoading ? 'loading-tbody' : ''}>
                        {wheels.map((wheel, index) => (

                          <tr key={index}>
                            <td>{((currentPage - 1) * itemsPerPage) + index + 1}</td>
                            <td>
                              {wheel.wheel_user_id?.first_name || wheel.creator?.first_name
                                ? `${wheel.wheel_user_id?.first_name || wheel.creator?.first_name || ''} ${wheel.wheel_user_id?.last_name || wheel.creator?.last_name || ''}`.trim()
                                : '-'}
                            </td>

                            <td>
                              {wheel.wheel_user_id?.phone_number || wheel.creator?.phone_number
                                ? `${wheel.wheel_user_id?.phone_number || wheel.creator?.phone_number || ''} `.trim()
                                : '-'}
                            </td>

                            <td>{wheel.wheel_name || '-'}</td>
                            <td>{wheel.spinning_time ? new Date(wheel.spinning_time).toLocaleDateString() : '-'}</td>
                            <td>
                              <span
                                className={`status-badge status-${(wheel.status || '').toLowerCase()}`}
                                onClick={() => handleStatusClick(wheel)}
                                style={{ cursor: wheel.status === "wfa" ? "pointer" : "default" }}
                              >
                                {wheel.status === "wfa"
                                  ? "Waiting For Approval"
                                  : wheel.status === "paymentpending"
                                    ? "Pending"
                                    : wheel.status}
                              </span>
                            </td>
                            <td>{wheel.prize}</td>
                            <td>{wheel.purchase_status || '-'}</td>
                            <td>
                              <button
                                className="action-btn"
                                onClick={() => {
                                  setShowLeadsPopup(true);
                                  fetchLeads(wheel.player, wheel.wheel_name);
                                }}
                                title="View Leads"
                              >
                                👥
                              </button>

                            </td>
                            <td>
                              <button
                                className="action-btn"
                                onClick={() => {
                                  fetchWheeledit(wheel._id);
                                }}
                                title="View Leads"
                              >
                                ✏️
                              </button>

                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination-controls">
                    <button
                      className="pagination-button"
                      onClick={handlePrevPage}
                      disabled={currentPage === 1 || tableLoading}
                    >
                      Previous
                    </button>
                    <span className="pagination-info">
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="pagination-button"
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages || tableLoading}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Leads Popup */}
          {showLeadsPopup && (
            <div className="popup-overlay">
              <div className="popup-content">
                <div className="popup-header">
                  <h3>Participants for {selectedWheelName}</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowLeadsPopup(false)}
                  >
                    ×
                  </button>
                </div>

                {isLoadingLeads ? (
                  <div className="loading">Loading participants...</div>
                ) : (
                  <div className="leads-table-container">
                    <table className="leads-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Phone Number</th>
                          <th>Participation Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentLeads.length > 0 ? (
                          currentLeads.map((lead, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstLead + index + 1}</td>
                              <td>{lead.phone_number}</td>
                              <td>{lead.created_date}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3">No participants found.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {selectedWheelLeads.length > 0 && (
                      <div className="pagination-controls">
                        <button
                          className="pagination-button"
                          onClick={handlePrevLeadsPage}
                          disabled={leadsCurrentPage === 1}
                        >
                          Previous
                        </button>
                        <span className="pagination-info">
                          Page {leadsCurrentPage} of {leadsTotalPages}
                        </span>
                        <button
                          className="pagination-button"
                          onClick={handleNextLeadsPage}
                          disabled={leadsCurrentPage === leadsTotalPages}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Confirmation Popup */}
          {showConfirmPopup && selectedWheel && (
            <div className="popup-overlay">
              <div className="popup-content">
                <div className="popup-header">Confirm Wheel Approval</div>
                <div className="wheel-details">
                  <div className="wheel-detail-item">
                    <div className="detail-label">Wheel Name:</div>
                    <div className="detail-value">{selectedWheel.wheel_name}</div>
                  </div>
                  <div className="wheel-detail-item">
                    <div className="detail-label">Creator:</div>
                    <div className="detail-value">
                      {selectedWheel.wheel_user_id.first_name} {selectedWheel.wheel_user_id.last_name}
                    </div>
                  </div>
                  <div className="wheel-detail-item">
                    <div className="detail-label">Set Price: <span style={{ color: '#d23030' }}>{errorprice && ('*')}</span></div>
                    <span>₹</span>
                    <input
                      type="number"
                      placeholder="Enter price"
                      className="detail-input"
                      value={selectedWheelprice}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setSelectedWheelprice(value);
                          calculateTotals(value, additionalFee, taxRate);
                        }
                      }}
                      required
                      min="1"
                      step="1"
                    />
                  </div>

                  <div className="wheel-detail-item">
                    <div className="detail-label">Additional Fee:</div>
                    <span>₹</span>
                    <input
                      type="number"
                      placeholder="Enter fee"
                      className="detail-input"
                      value={additionalFee}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setAdditionalFee(value);
                          calculateTotals(selectedWheelprice, value, taxRate);
                        }
                      }}
                      min="0"
                      step="1"
                    />
                  </div>

                  <div className="wheel-detail-item">
                    <div className="detail-label">Subtotal:</div>
                    <div className="detail-value">₹{calculateSubtotal()}</div>
                  </div>

                  <div className="wheel-detail-item">
                    <div className="detail-label">Tax Rate:</div>
                    <input
                      type="number"
                      placeholder="Enter tax rate"
                      className="detail-input"
                      value={taxRate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setTaxRate(value);
                          calculateTotals(selectedWheelprice, additionalFee, value);
                        }
                      }}
                      min="0"
                      step="0.1"
                    />
                    <span>%</span>
                  </div>

                  <div className="wheel-detail-item">
                    <div className="detail-label">Tax Amount:</div>
                    <div className="detail-value">₹{calculateTax()}</div>
                  </div>

                  <div className="wheel-detail-item total-amount">
                    <div className="detail-label">Total Amount:</div>
                    <div className="detail-value">₹{calculateTotal()}</div>
                  </div>

                  <div className="wheel-detail-item">
                    <div className="detail-label">Spin Date:</div>
                    <div className="detail-value">
                      {selectedWheel.spinning_time
                        ? new Date(selectedWheel.spinning_time).toLocaleDateString()
                        : 'Not specified'}
                    </div>
                  </div>
                </div>

                <p>Are you sure you want to approve this wheel and change its status to "Published"?</p>

                <div className="popup-buttons">
                  <button
                    className="popup-button cancel-button"
                    onClick={() => {
                      setShowConfirmPopup(false);
                      setSelectedWheel(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="popup-button confirm-button"
                    onClick={handleConfirmation}
                    disabled={isConfirming}
                  >
                    {isConfirming ? 'Approving...' : 'Approve'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Dashboard;